import * as DAOUtils from "../utils/DAOUtils";
import { API_URL } from "@/consts/api.consts";

export function getTranslations(lang) {
  return DAOUtils.get(`/interfacestrings/${lang}`);
}

export function getMissingTranslations(lang, body) {
  // Force it to be tst env for dev env - this is the part of the missing translations submission process
  DAOUtils.post(
    `${
      API_URL === "https://ntl-dev-oraylis-ct-as-backend-we.azurewebsites.net"
        ? "https://ntl-dev-oraylis-ct-as-backend-we.azurewebsites.net" //"https://ntl-tst-bd-ct-as-backend-we.azurewebsites.net"
        : ""
    }/interfacestrings/${lang}`,
    body
  );
}
